// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfile"]);
}

function unwrap_response_createTeamMarketingProfile(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["TeamMarketingProfileCreated"]);
}

var variablesConverter = {"createTeamMarketingProfileInput":{"website":{"b":""}},"__root":{"input":{"r":"createTeamMarketingProfileInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile_TeamMarketingProfile_website":{"b":""},"createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile":{"u":"response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile"},"createTeamMarketingProfile":{"u":"response_createTeamMarketingProfile"}}};

var wrapResponseConverterMap = {
  response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile: RescriptRelay_Internal.wrapUnion,
  response_createTeamMarketingProfile: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile_TeamMarketingProfile_website":{"b":""},"createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile":{"u":"response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile"},"createTeamMarketingProfile":{"u":"response_createTeamMarketingProfile"}}};

var responseConverterMap = {
  response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile: unwrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile,
  response_createTeamMarketingProfile: unwrap_response_createTeamMarketingProfile
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamSize",
      "storageKey": null
    }
  ],
  "type": "TeamMarketingProfile",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTeamMarketingProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createTeamMarketingProfile",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "marketingProfile",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileCreated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTeamMarketingProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createTeamMarketingProfile",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountV5",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "marketingProfile",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "TeamMarketingProfileCreated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51c50ccfb70db7f7247af37139f090d6",
    "id": null,
    "metadata": {},
    "name": "CreateTeamMarketingProfileMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTeamMarketingProfileMutation(\n  $input: CreateTeamMarketingProfileInput!\n) {\n  createTeamMarketingProfile(input: $input) {\n    __typename\n    ... on TeamMarketingProfileCreated {\n      account {\n        marketingProfile {\n          __typename\n          ... on TeamMarketingProfile {\n            teamName\n            website\n            brokerage\n            teamSize\n          }\n          ... on Node {\n            __isNode: __typename\n            __typename\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n"
  }
};
})());

var wrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile = RescriptRelay_Internal.wrapUnion;

var wrap_response_createTeamMarketingProfile = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile = unwrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile;
exports.wrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile = wrap_response_createTeamMarketingProfile_TeamMarketingProfileCreated_account_marketingProfile;
exports.unwrap_response_createTeamMarketingProfile = unwrap_response_createTeamMarketingProfile;
exports.wrap_response_createTeamMarketingProfile = wrap_response_createTeamMarketingProfile;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
